// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	linkedin: {
		clientId: '86lqpt4c2zlf57',
	},
	google: {
		clientId: '179779178843-cik41cd628og1meleo75rlamd6kr0cm4.apps.googleusercontent.com',
	},
	urls: {
		signalRURL_Obj: "https://uat-common-api-v5.unnanu.com/signalr/",
		messageUrl_Obj: "https://uat-common-api-v5.unnanu.com/api/v1/",
		facebookAppID: "138557023267771",
	//	facebookAppID: "295962714193867",
		serverUrl_Obj: "https://uat-recruit-api-v5.unnanu.com/api/v1/",
		ssnUrl_Obj: "https://uat-recruit-api-v5.unnanu.com/api/v1/",
		paymentUrl_Obj: "https://uat-payments-v5.unnanu.com/api/v1/",
		// socketServerURL: 'http://localhost:3001',
		socketServerURL: "https://uat-realtime-v5.unnanu.com/",
		fileServerUrl_Obj: "https://cdn.unnanu.com",
		fileServerUrlHire_Obj: "https://cdn.unnanu.com",
		baseURL_Obj: window.location.origin,
		hire_url_obj: "https://uat-hire.unnanu.com",
		job_board: "https://uat.jobs.unnanu.com",
		landing_page: "https://uat.talent.unnanu.com",
		app_url_obj: "https://uat.app.unnanu.com",
		hire_landing_page: "https://unnanu.com",
		SIGNUP_APP:"https://uat-hire-oth-v5.unnanu.com",
		// otherApiUrl_Obj: "http://localhost:5271/api/v1/",
		otherApiUrl_Obj: "https://uat-talent-oth-v5.unnanu.com/api/v1/",
		redirect_url:'https://uat.app.unnanu.com/login',
		resume_watermark:'https://unnanu-wmark-uat.azurewebsites.net/watermark'

	},
	keys: {
		ga_key: null
	}
};
